import React, {useState, useEffect, useRef} from "react";
import {Form, Table, Input, DatePicker, Tooltip} from "antd";
import FormSearchFilter from "../../components/FormSearchFilter";
import APIService from "../../service/APIService";
import moment from "moment";
import getColumnSearchProps from "../../components/TableColumnSearchProps";

const {RangePicker} = DatePicker;
const dateFormatPicker = "DD-MM-YYYY";


export default function FishLogDetailPage() {
  const [dataTable, setDataTable] = useState([]);
  const [filterDate, setFilterDate] = useState({
    timeFrom: "", timeTo: "",
  });

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [filterText, setFilterText] = useState('');
  const [filterColumn, setFilterColumn] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const searchInput = useRef(null);

  const columns = [{
    title: "ID", dataIndex: "id", key: "id", width: 100, align: "center",
  }, {
    title: "USER",
    dataIndex: "player",
    key: "player",
    width: 160,
    align: "center", ...getColumnSearchProps(dataTable.length, "player", setFilterText, setFilterColumn, setCurrentPage, searchInput, searchText, setSearchText, searchedColumn, setSearchedColumn)
  }, {
    title: "PHÒNG", dataIndex: "room", key: "room", width: 100, align: "center",
  }, {
    title: "BÀN", dataIndex: "table", key: "table", width: 100, align: "center",
  }, {
    title: "VÁN", dataIndex: "round", key: "round", width: 140, align: "center",
  }, {
    title: "MONEY GET", dataIndex: "moneyGet", key: "moneyGet", width: 140, align: "center",
  }, {
    title: "ĐẠN", dataIndex: "bullet", key: "bullet", width: 140, ellipsis: {
      showTitle: false,
    }, render: data => (<Tooltip placement="topLeft" title={data}>
      {data}
    </Tooltip>), align: "center",
  }, {
    title: "CÁ BẮN", dataIndex: "fishHit", key: "fishHit", width: 140, ellipsis: {
      showTitle: false,
    }, render: data => (<Tooltip placement="topLeft" title={data}>
      {data}
    </Tooltip>), align: "center",
  },

    {
      title: "CÁ CHẾT", dataIndex: "fishDie", key: "fishDie", width: 140, ellipsis: {
        showTitle: false,
      }, render: data => (<Tooltip placement="topLeft" title={data}>
        {data}
      </Tooltip>), align: "center",
    },


    {
      title: "LÚC",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      width: 140,
      render: (data, data1, index) => (<p>{moment(data).format('DD-MM-YYYY hh:mm:ss')}</p>),
    },];

  async function getFishLogDetailList(filter = {}, page = 1, size = 10) {
    try {
      let wherePlayerId = "";
      let filterWhere = [];
      if (filter["player"]) {
        wherePlayerId = ` player like '%${filter["player"]}%'`;
        filterWhere.push(wherePlayerId);
      }
      const data = await APIService.fishLogDetailList(filterDate.timeFrom, filterDate.timeTo, filterWhere.join(" AND "), page, size);
      if (data) {
        setDataTable(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  function onChangePage(page, _pageSize) {
    if (_pageSize !== pageSize) {
      setPageSize(_pageSize)
      setCurrentPage(1);
    } else if (page !== currentPage) {
      setCurrentPage(page)
    }
  }

  useEffect(() => {
    getFishLogDetailList({
      [filterColumn]: filterText
    }, currentPage, pageSize).then();
  }, [filterDate, currentPage, pageSize, filterText]);

  return (<>
    <FormSearchFilter
      title="Fish Log Detail"
      initialValues={filterDate}
      onFormLayoutChange={(value) => {
        if (value.time) {
          setFilterDate({
            ...filterDate,
            timeFrom: moment(value.time[0]).format('YYYY-MM-DD'),
            timeTo: moment(value.time[1]).format('YYYY-MM-DD'),
          });
        } else {
          setFilterDate({timeFrom: "", timeTo: ""});
        }
      }}
    >
      <Form.Item label="Time" className="form-datepicker-filter" name="time">
        <RangePicker format={dateFormatPicker}/>
      </Form.Item>
    </FormSearchFilter>

    <Table columns={columns} rowKey={'id'} dataSource={dataTable} pagination={{
      position: ['top'], total: 1000, current: currentPage, onChange: onChangePage, defaultCurrent: 1
    }}/>
  </>);
}
